export default __webpack_public_path__ + "static/media/plastico.45e83dbd.jpg";